export const steps = [
    {
        id: 1,
        imagem: "https://static.meucupom.com/media/new-homepage-2023/how-to-use/IMGS__1.png",
    },
    {
        id: 2,
        imagem: "https://static.meucupom.com/media/new-homepage-2023/how-to-use/IMGS__2.png",
    },
    {
        id: 3,
        imagem: "https://static.meucupom.com/media/new-homepage-2023/how-to-use/IMGS__3.png",
    },
    {
        id: 4,
        imagem: "https://static.meucupom.com/media/new-homepage-2023/how-to-use/IMGS__4.png",
    },
]